import { Provider } from 'react-redux'
import { createReduxStore } from '../config/store'

export const StoreProvider = ({ children, initialState }) => {
  const store = createReduxStore(initialState)

  return <Provider store={store}>{children}</Provider>
}
